<ng-container thr-parent-form>
    <thr-contract-form-participant-legal-person
        [client]="client"
        [currentAttorneyInFact]="attorneyInFact"
    ></thr-contract-form-participant-legal-person>

    <div class="bg-gray-gradient mt-4 pt-4 pb-3">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row flex-nowrap justify-content-between align-items-end">
                        <div class="col-auto flex-shrink-1">
                            <h2 class="mat-subheading-1 text-blue font-weight-bold mb-2">
                                {{ 'form.attorney-in-fact-data' | translate }}
                            </h2>
                            <h3
                                class="text-blue mat-display-1 font-weight-bold mb-0"
                                [innerHTML]="'form.attorney-in-fact' | translate"
                            ></h3>
                        </div>
                        <div class="col-auto">
                            <i class="icon-natural text-blue"></i>
                        </div>
                    </div>
                    <hr class="mt-1 mb-3" />
                    <div class="row">
                        <div class="col-12">
                            <label>{{ 'form.participant-type' | translate }}</label
                            ><br />
                            <mat-radio-group name="type" [(ngModel)]="attorneyInFact.type" [required]="true">
                                <mat-radio-button class="mr-5" name="natural" color="blue-gray" [value]="ClientType.NATURAL_PERSON">
                                    {{ 'form.natural' | translate }}
                                </mat-radio-button>
                                <mat-radio-button class="ml-5" name="legal" color="blue-gray" [value]="ClientType.LEGAL_PERSON">
                                    {{ 'form.legal' | translate }}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <hr class="mt-2 mb-4" />
                </div>
            </div>
        </div>

        <div *ngIf="attorneyInFact.type === ClientType.NATURAL_PERSON">
            <thr-contract-form-participant-natural-person
                [client]="attorneyInFact"
                [pupil]="client"
            ></thr-contract-form-participant-natural-person>
        </div>

        <div class="container" *ngIf="attorneyInFact.type === ClientType.LEGAL_PERSON">
            <div class="row flex-nowrap align-items-center mb-2">
                <div class="col-auto">
                    <i class="icon-exclamation red-icon-exclamation"></i>
                </div>
                <div class="col-auto flex-shrink-1">
                    <input type="checkbox" class="d-none" name="disabledLegal" id="disabledLegal" required [(ngModel)]="disabledLegal" />
                    <p class="text-error font-weight-bold mb-0">
                        {{ 'form.legal-error' | translate }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</ng-container>
